import React from 'react';

const BannerTable = ({ ads, selectedRows, handleRowSelect, handleSelectAll, selectAll, handleImageClick, removeRow, isDark, currentPage, pageSize, selectedAdvertiserFilter, showAdvertiserDropdown, setShowAdvertiserDropdown, getUniqueAdvertisers, handleAdvertiserFilter, selectedTypeFilter, showTypeDropdown, setShowTypeDropdown, getUniqueTypes, handleTypeFilter, selectedLanguageFilter, showLanguageDropdown, setShowLanguageDropdown, getUniqueLanguages, handleLanguageFilter, selectedStartDateFilter, showStartDateDropdown, setShowStartDateDropdown, getUniqueStartDates, handleStartDateFilter, selectedEndDateFilter, showEndDateDropdown, setShowEndDateDropdown, getUniqueEndDates, handleEndDateFilter }) => {
  return (
    <div className="perzsi-table-container">
      <div className="overflow-x-auto">
        <table className="perzsi-table">
          <thead>
            <tr>
              <th className="w-16">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="w-5 h-5 rounded border-2 border-gray-300 text-perzsi-yellow focus:ring-2 focus:ring-perzsi-yellow focus:border-perzsi-yellow cursor-pointer"
                />
              </th>
              <th>Name</th>
              <th>Description</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Advertiser {selectedAdvertiserFilter && `(${selectedAdvertiserFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowAdvertiserDropdown(!showAdvertiserDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showAdvertiserDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleAdvertiserFilter('');
                            setShowAdvertiserDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedAdvertiserFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Advertisers
                        </div>
                        {getUniqueAdvertisers().map((advertiser) => (
                          <div
                            key={advertiser}
                            onClick={() => {
                              handleAdvertiserFilter(advertiser);
                              setShowAdvertiserDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedAdvertiserFilter === advertiser ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {advertiser}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Campaign</th>
              <th>Tracking Link</th>
              <th>Images</th>
              <th>Image Dimensions</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Type {selectedTypeFilter && `(${selectedTypeFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowTypeDropdown(!showTypeDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showTypeDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleTypeFilter('');
                            setShowTypeDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedTypeFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Types
                        </div>
                        {getUniqueTypes().map((type) => (
                          <div
                            key={type}
                            onClick={() => {
                              handleTypeFilter(type);
                              setShowTypeDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedTypeFilter === type ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {type}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Language {selectedLanguageFilter && `(${selectedLanguageFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showLanguageDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleLanguageFilter('');
                            setShowLanguageDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedLanguageFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Languages
                        </div>
                        {getUniqueLanguages().map((language) => (
                          <div
                            key={language}
                            onClick={() => {
                              handleLanguageFilter(language);
                              setShowLanguageDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedLanguageFilter === language ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {language}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Start Date {selectedStartDateFilter && `(${selectedStartDateFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowStartDateDropdown(!showStartDateDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showStartDateDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleStartDateFilter('');
                            setShowStartDateDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedStartDateFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Start Dates
                        </div>
                        {getUniqueStartDates().map((startDate) => (
                          <div
                            key={startDate}
                            onClick={() => {
                              handleStartDateFilter(startDate);
                              setShowStartDateDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedStartDateFilter === startDate ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {startDate}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    End Date {selectedEndDateFilter && `(${selectedEndDateFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowEndDateDropdown(!showEndDateDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showEndDateDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleEndDateFilter('');
                            setShowEndDateDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedEndDateFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All End Dates
                        </div>
                        {getUniqueEndDates().map((endDate) => (
                          <div
                            key={endDate}
                            onClick={() => {
                              handleEndDateFilter(endDate);
                              setShowEndDateDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedEndDateFilter === endDate ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {endDate}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {ads.map((ad, index) => {
              const globalIndex = (currentPage - 1) * pageSize + index;
              const isSelected = selectedRows.has(globalIndex);

              return (
                <tr key={index} className={isSelected ? (isDark ? 'bg-blue-900/30' : 'bg-yellow-50') : (isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-50')}>
                  <td>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleRowSelect(index)}
                      className="w-5 h-5 rounded border-2 border-gray-300 text-perzsi-yellow focus:ring-2 focus:ring-perzsi-yellow focus:border-perzsi-yellow cursor-pointer"
                    />
                  </td>
                  <td className="font-medium">{ad.Name}</td>
                  <td className="max-w-xs truncate">{ad.Description}</td>
                  <td>{ad.AdvertiserName}</td>
                  <td>{ad.CampaignName}</td>
                  <td className="max-w-xs">
                    {ad.TrackingLink && (
                      <div>
                        <a
                          href={ad.TrackingLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline font-medium"
                        >
                          Link
                        </a>
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="ads-image-container">
                      {ad.ImageUrls && ad.ImageUrls.map((url, imgIndex) => (
                        <div key={imgIndex} style={{ marginBottom: '5px' }}>
                          <img
                            src={url}
                            alt={`Ad ${index + 1} - ${imgIndex + 1}`}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                            onClick={() => handleImageClick(url, `Ad ${index + 1} - Image ${imgIndex + 1}`)}
                            style={{
                              maxWidth: '100px',
                              maxHeight: '50px',
                              marginRight: '5px',
                              cursor: 'pointer',
                              border: '2px solid transparent',
                              borderRadius: '4px'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.border = '2px solid #FFD700';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.border = '2px solid transparent';
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className={`text-xs ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                      {ad.ImageDimensions && ad.ImageDimensions.map((dim, imgIndex) => (
                        <div key={imgIndex}>{dim}</div>
                      ))}
                    </div>
                  </td>
                  <td>{ad.Type}</td>
                  <td>{ad.Language}</td>
                  <td>{ad.StartDate}</td>
                  <td>{ad.EndDate}</td>
                  <td>
                    <button
                      className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm transition-colors duration-200"
                      onClick={() => removeRow(index)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BannerTable;
